module.exports = __webpack_public_path__ + "static/media/bold.4554007b.svg";